import PropTypes from 'prop-types';

import { useContext } from 'react';

import BufferContext from '../../context/materialcapture/BufferContext';

import Grid from "@mui/material/Grid";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

const BufferComponetForm = ({ index, data }) => {
  const { 
    initialValues, showPointer, formErrors, handleComponentInputChange, 
    handleComponentDelete 
  } = useContext(BufferContext);

  return(
    <Grid container spacing={1} sx={{ mt: 0 }}>
      <Grid item xs={5.75}>
        <Autocomplete
          value={data?.buffer_component_name}
          onChange={(e, newValue) => 
            handleComponentInputChange(e, data?.index, 'buffer_component_name', newValue)
          }
          onInputChange={(e, newValue) =>
            handleComponentInputChange(e, data?.index, 'buffer_component_name', newValue)
          }
          options={initialValues?.bufferComponentNameArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label={`Buffer component ${index + 1} *`}
              placeholder="Type to search Buffer component name..." 
              helperText={formErrors[`buffer_component_name-${data?.index}`]}
              error={`buffer_component_name-${data?.index}` in formErrors}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={5.75}>
        <TextField
          varient="outlined"
          label={`Buffer component ${index + 1} (concentration mM) *`}
          name={`buffer_component_concentration_mmol-${data?.index}`}
          value={data?.buffer_component_concentration_mmol}
          onChange={e => 
            handleComponentInputChange(
              e, data?.index, 'buffer_component_concentration_mmol', e.target.value
            )
          }
          helperText={formErrors[`buffer_component_concentration_mmol-${data?.index}`]}
          error={`buffer_component_concentration_mmol-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid 
        item 
        xs={0.5} 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}
      >
        <RemoveCircleOutlineIcon 
          color='error'
          fontSize='medium'
          sx={{
            cursor: showPointer ? 'pointer' : 'not-allowed'
          }}
          onClick={e => handleComponentDelete(data?.index, data?.id)}
        />
      </Grid>
    </Grid>
  );
};

BufferComponetForm.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default BufferComponetForm;